<template>
  <div class="next-steps mt-3" :style="{ '--next-step-color': color }">
    <div class="next-step-color d-flex align-items-center paragraph-s">
      <eg-icon :icon="icon" class="mr-1" /> {{ title }}
    </div>
    <slot name="content">
      <template v-if="typeof text === 'string'">
        <div v-if="isList" class="mt-2 paragraph-s">
          <ul>
            <li v-for="(item, index) in listItems" :key="index">{{ item }}</li>
          </ul>
        </div>
        <div v-else class="mt-2 paragraph-s">{{ text }}</div>
      </template>
      <component :is="text" v-else></component>
    </slot>
  </div>
</template>

<script>
import EgIcon from "@/components/global/eg_icon.vue";

export default {
  components: {
    EgIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: [String, Function],
      required: true,
    },
    isList: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
      default: "bulb-light",
    },
    color: {
      type: String,
      required: false,
      default: "#17a2b8",
    },
  },
  computed: {
    listItems() {
      return this.text.split("\n");
    },
  },
};
</script>

<style lang="scss" scoped>
.next-steps {
  padding: 0.75rem;
  border-radius: 8px;
  /*background: color-mix(in srgb, var(--next-step-color) 4%, transparent);*/
  background: var(--color-surface-semantic-informative-light);
  .next-step-color {
    font-size: var(--typography-font-size-fs-200);
  }
}

.next-step-color {
  color: var(--next-step-color);
}
</style>
